import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CustomSelect from "../../Components/CustomSelect";
import moment from "moment";

const parseFloatSafe = (val) => {
  if (val === undefined || val === null || val === "") return 0;
  const parsed = parseFloat(val);
  return isNaN(parsed) ? 0 : parsed;
};

export default function Tournament() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  // const [searchSubType] = React.useState();
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  // const [searchTourName, setSearchTourName] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const TournamentSchema = Yup.object().shape({
    tournamentName: Yup.string().required("required"),
    gameName: Yup.string().required("required"),
    joinDate: Yup.string().required("required"),
    minJoinPlayer: Yup.number().required("required"),
    maxJoinPlayer: Yup.number().required("required"),
    joinAmount: Yup.number().required("required"),
    terminate: Yup.string().required("required"),
    terminateMsg: Yup.string().required("required"),
    active: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getTournamentData();
  }, []);

  const getTournamentData = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/tournament/get-tournament`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getTournamentData error :::", error);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const updateTournament = (value) => {
    console.log(
      "updateTournament value :::",
      value,
      openValue,
      rowValue._id,
      rowValue
    );
    const margeData = { ...value, id: rowValue._id };
    axios
      .patch(
        `${API_URL}/api/admin/tournament/update-tournament/${rowValue._id}`,
        margeData
      )
      .then((res) => {
        console.log("edit :::", res.data);
        const data = {
          message: "tournament",
        };
        if (res.data.status) {
          successEdit();
          socket.emit("tournamentUpdate", data);
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        setbuttonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(`${API_URL}/api/admin/tournament/add-tournament`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        const data = {
          message: "tournament",
        };
        if (result.data.status) {
          successAdd();
          socket.emit("tournamentAdd", data);
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        setbuttonLoader(false);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this tournament record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          const data = {
            message: "tournament",
          };
          socket.emit("tournamentDelete", data);
          setbuttonLoader(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The tournament record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    setbuttonLoader(true);
    axios
      .delete(`${API_URL}/api/admin/tournament/delete-tournament/${e._id}`, {
        id: e._id,
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status) {
          successDeleted();
        }
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The tournament record has been added successfully.</p>
      </SweetAlert>
    );
  };

  const successEdit = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getTournamentData();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The tournament record has been updated successfully.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  tournamentName: rowValue ? rowValue?.tournamentName : "",
                  gameName: rowValue ? rowValue?.gameName : "",
                  joinDate: rowValue ? rowValue?.joinDate : "",
                  minJoinPlayer: rowValue ? rowValue?.minJoinPlayer : 0,
                  maxJoinPlayer: rowValue ? rowValue?.maxJoinPlayer : 0,
                  joinAmount: rowValue ? rowValue?.joinAmount : 0,
                  terminate: rowValue ? rowValue?.terminate : false,
                  terminateMsg: rowValue ? rowValue?.terminateMsg : "",
                  active: rowValue ? rowValue?.active : true,
                }}
                validationSchema={TournamentSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log("update formik value :::", values, openValue);
                  const parsedValues = {
                    ...values,
                    joinAmount: parseFloatSafe(values.joinAmount),
                  };
                  if (openValue === 1) {
                    addNewTournament(parsedValues);
                  }
                  if (openValue === 2) {
                    updateTournament(parsedValues);
                  }
                }}
              >
                {({ touched, errors, values, setFieldValue }) => (
                  <Form>
                    <div className="row">
                      {/* Names */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Tournament Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="tournamentName"
                            placeholder="Enter Tournament Name"
                            className={`mt-1 form-control ${touched.tournamentName && errors.tournamentName ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="tournamentName" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Game Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="gameName"
                            placeholder="Enter Game Name"
                            className={`mt-1 form-control ${touched.gameName && errors.gameName ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="gameName" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      {/* Schedule & Fees */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Join Date & Time <span className="text-danger">*</span></label>
                          <Field
                            type="datetime-local"
                            name="joinDate"
                            className={`mt-1 form-control ${touched.joinDate && errors.joinDate ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="joinDate" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Join Amount <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="joinAmount"
                            placeholder="0.00"
                            className={`mt-1 form-control ${touched.joinAmount && errors.joinAmount ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*\.?[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("joinAmount", e.target.value);
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="joinAmount" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      {/* Players */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Min Join Player <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="minJoinPlayer"
                            placeholder="Min players"
                            className={`mt-1 form-control ${touched.minJoinPlayer && errors.minJoinPlayer ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("minJoinPlayer", e.target.value === "" ? 0 : parseInt(e.target.value));
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="minJoinPlayer" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Max Join Player <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="maxJoinPlayer"
                            placeholder="Max players"
                            className={`mt-1 form-control ${touched.maxJoinPlayer && errors.maxJoinPlayer ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              const re = /^[0-9]*$/;
                              if (e.target.value === "" || re.test(e.target.value)) {
                                setFieldValue("maxJoinPlayer", e.target.value === "" ? 0 : parseInt(e.target.value));
                              }
                            }}
                          />
                          <ErrorMessage component="div" name="maxJoinPlayer" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      {/* Termination */}
                      <div className="col-md-6">
                        <CustomSelect
                          label="Termination Status"
                          name="terminate"
                          options={[
                            { value: true, label: "ON" },
                            { value: false, label: "OFF" },
                          ]}
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Termination Message <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="terminateMsg"
                            placeholder="Enter reason for termination"
                            className={`mt-1 form-control ${touched.terminateMsg && errors.terminateMsg ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="terminateMsg" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-6">
                        <CustomSelect
                          label="Tournament Status"
                          name="active"
                          options={[
                            { value: true, label: "Active" },
                            { value: false, label: "Inactive" },
                          ]}
                        />
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-4 border-top">
                      <button
                        style={{ width: "110px", height: "38px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px", height: "38px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            <div class="pl-4 pr-4 pt-4">
              <div className="row justify-content-end">
                <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                  {accessObject?.addBlockBlastTour === true && (
                    <>
                      <button
                        onClick={() => {
                          openAddTournament(1);
                        }}
                        type="button"
                        className="btn btn-primary"
                      >
                        <AddIcon />
                        Add New
                      </button>
                    </>
                  )}
                </div>
                {/* <div className="mt-2 col-md-6 col-lg-6 d-flex justify-content-start justify-content-lg-end">
                  <div>
                    <input
                      class="input-simple"
                      type="text"
                      placeholder="Tournament Name"
                      value={searchSubType}
                      onChange={(e) => setSearchTourName(e.target.value)}
                    />
                  </div>
                </div> */}
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Tour Name</th>
                    <th>Game Name</th>
                    <th>Join Date</th>
                    <th>Min Join Player</th>
                    <th>Max Join Player</th>
                    <th>Join Amount</th>
                    <th>Terminate</th>
                    <th>Terminate Msg</th>
                    <th>Status</th>
                    {(accessObject?.editBlockBlastTour === true ||
                      accessObject?.deleteBlockBlastTour === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getBlockBlastTour === true ? (
                    <>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td style={{ textAlign: "center" }}>
                                        {moment(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{item.tournamentName}</td>
                                      <td>{item.gameName}</td>
                                      <td>
                                        {moment(item.joinDate).format(
                                          "DD/MM/YYYY HH:mm:ss"
                                        )}
                                      </td>
                                      <td>{item.minJoinPlayer}</td>
                                      <td>{item.maxJoinPlayer}</td>
                                      <td>{item.joinAmount}</td>
                                      <td>{item.terminate ? "On" : "Off"}</td>
                                      <td>{item.terminateMsg}</td>
                                      <td>{item.active ? "Active" : "Inactive"}</td>
                                      {(accessObject?.editBlockBlastTour ===
                                        true ||
                                        accessObject?.deleteBlockBlastTour ===
                                        true) && (
                                          <td className="justify-content-evenly ">
                                            <div className="d-flex">
                                              {accessObject?.editBlockBlastTour ===
                                                true && (
                                                  <EditIcon
                                                    className="mr-3 courser"
                                                    onClick={() =>
                                                      clickEditButton(item)
                                                    }
                                                  />
                                                )}
                                              {accessObject?.deleteBlockBlastTour ===
                                                true && (
                                                  <ClearIcon
                                                    className="courser text-danger"
                                                    onClick={() =>
                                                      warningWithConfirmMessage(
                                                        item
                                                      )
                                                    }
                                                  />
                                                )}
                                            </div>
                                          </td>
                                        )}
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={14} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={14} className="p-3">
                        <h5 className="text-center mb-0">Access Denied</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {accessObject?.getBlockBlastTour === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getBlockBlastTour === true &&
              tableData.length !== 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={tableData.length}
                />
              )}
          </div>
        </div>
      )}
    </>
  );
}
